import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=dbfd472e&scoped=true&"
var script = {}
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=dbfd472e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfd472e",
  null
  
)

export default component.exports